import "./Project.css";

export default function ProjectCard({ project }) {
  // Hide link for 'ongoing' or 'active' status
  const hideLink = ["ongoing", "active"].includes(project.status.toLowerCase());

  return (
    <div className="project-card">
      <div className="project-image-wrapper">
        <img src={project.image} alt={project.title} className="project-image" />
      </div>
      <div className="project-content">
        <h3 className="project-title">{project.title}</h3>
        <p className="project-desc">{project.description}</p>
        <div className="project-footer">
          <span className={`project-status project-status-${project.status}`}>
            {project.status.toUpperCase()}
          </span>
          {!hideLink && (
            <a
              href={project.link}
              className="project-link-button"
              target="_blank"
              rel="noreferrer"
            >
              View →
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
